import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
    marginBottom: theme.marginBase * 2,
  },
  title: {
    ...theme.fonts.label,
    textTransform: 'uppercase',
  },

  iconContainer: {
    width: theme.iconSize.large,
    height: theme.iconSize.large,
    borderRadius: theme.iconSize.large / 2,
    backgroundColor: theme.colors.blueMuted,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: theme.iconSize.small,
    color: theme.colors.blue,
  },
  separator: {
    borderTop: {
      width: 1,
      style: 'solid',
      color: theme.colors.grayBorder,
    },
    borderColor: 'transparent',
  },
}));

interface Props {
  title: string;
  icon: string;
}

export const EventPopoverTitle = ({ title, icon }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.content}>
        <div className={classes.iconContainer}>
          <i className={classNames(icon, classes.icon)} />
        </div>
        <h5 className={classes.title}>{title}</h5>
      </div>

      <hr className={classes.separator} />
    </>
  );
};
